// Brand modal — dark overlay + bordered surface card, matching the design system.
import React, { useEffect } from "react";
import { C, F } from "../brand/apo";

export function Modal({
  open,
  onClose,
  title,
  sub,
  children,
  width = 520,
}: {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  sub?: React.ReactNode;
  children: React.ReactNode;
  width?: number;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 900,
        background: "rgba(6,9,12,0.72)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width,
          maxWidth: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          background: C.surface,
          border: `1px solid ${C.lineHi}`,
          boxShadow: "0 24px 80px rgba(0,0,0,0.55)",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "18px 22px", borderBottom: `1px solid ${C.line}` }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontFamily: F.display, fontWeight: 500, fontSize: 20, letterSpacing: "-0.02em", color: C.fgDark }}>{title}</div>
            {sub && <div style={{ fontSize: 13, color: C.fgMute, marginTop: 5, lineHeight: 1.5 }}>{sub}</div>}
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{ background: "transparent", border: "none", color: C.fgMute, cursor: "pointer", fontSize: 20, lineHeight: 1, padding: 2 }}
          >
            ×
          </button>
        </div>
        <div style={{ padding: "20px 22px" }}>{children}</div>
      </div>
    </div>
  );
}
